import React, { useContext, useEffect } from "react";
import "./Sidebar.scss";
import MyContext from "../Context/MyContext";
import Profile from "../../assets/profile.png";
import { useLocation, useNavigate } from "react-router-dom";
import Data from "./Json";

const Sidebar = () => {
  const navigate = useNavigate();
  const {
   openLogoutModal,
    handleNavClick,
    token,
  
    logintime,
 
    usertoken,
  } = useContext(MyContext);

  useEffect(() => {
    const storedPath = sessionStorage.getItem("path");
    if (storedPath) navigate(storedPath);
  }, [navigate]);

  const location = useLocation();
  const All = [
    "/",
    "/profile",
    "/projects",
    "/learning",
    "/work-completed",
    "/reports",
    "/certificate",
    "/timeline",
  ];

  if (!All.includes(location.pathname)) {
    return null;
  }

  return (
    <div className="sidebar-main">
      <div className="profile-section">
        <img src={Profile} alt="Profile" className="profile-picture" />
        <div className="profile-info">
          <h4>{token ? usertoken.name : "User Not Found"}</h4>
          <p>{usertoken.domain ? usertoken.domain : "not found"}</p>
          <span className="status online">
            {token ? `Last login: ${logintime}` : "Not Found"}
          </span>
        </div>
      </div>

      <nav className="navigation">
        <ul>
          {Data.map((item) => (
            <li
              className={`nav-item ${
                item.path === location.pathname ? "active" : ""
              }`}
              onClick={() => handleNavClick(item.path)}
              key={item.id}
            >
              <span
                className={`icon ${
                  item.path === location.pathname ? "activeicon" : ""
                }`}
              >
                {item.icon}
              </span>
              {item.title}
            </li>
          ))}
        </ul>
      </nav>

      <div className="settings">
        <button
          className={`settings-btn ${
            location.pathname === "/profile" ? "make" : ""
          }`}
          onClick={() => handleNavClick("/profile")}
        >
          Profile Settings
        </button>
        <button className="settings-btn" onClick={openLogoutModal}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
